import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';
import { VraagboomAntwoord } from './vraagboom-antwoord';

export class Groep {
    constructor(
    public id: string,
    public titel: string) {
    this.resultaten = [];
  }

  resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];
}
